import { useRef, useEffect } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { enterpriseMembersErrorSelector } from '@hero/redux-data/backoffice/enterpriseMembers/selectors';
import { useNotifications } from '../../context/notification';
const useEnterpriseMemberListFailAlert = () => {
    const { error, originalMessage } = useSelector(enterpriseMembersErrorSelector, shallowEqual);
    const { addNotification, removeNotification } = useNotifications();
    const id = useRef();
    useEffect(() => {
        id.current && removeNotification(id.current);
        if (error) {
            id.current = addNotification({
                type: 'fail',
                message: originalMessage?.replace(/[_-]/g, ' ') || 'Error fetching organization members.'
            });
        }
        else {
            id.current = undefined;
        }
    }, [addNotification, removeNotification, error, originalMessage]);
};
export default useEnterpriseMemberListFailAlert;
